import { TFunction } from 'i18next'
import { useCallback } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { getAutomaticPaymentRemindersSettings } from '../query-api'
import { PaymentRemindersSettings } from '../types/paymentReminders/paymentRemindersSettings'
import { getAutomaticPaymentRemindersDefaultValues } from '../utils/getAutomaticPaymentRemindersDefaultValues'

interface SelectSettingsResponse {
  data: PaymentRemindersSettings
}

export const useGetAutomaticPaymentRemindersSettings = (t: TFunction) => {
  const { organization } = useUserOrganization()
  const organizationName = organization?.name

  const selectPaymentRemindersSettings = useCallback(
    (response: SelectSettingsResponse): PaymentRemindersSettings | undefined => {
      const automaticPaymentRemindersSettings = response?.data
      if (!automaticPaymentRemindersSettings) {
        return getAutomaticPaymentRemindersDefaultValues(t, organizationName)
      }

      return {
        ...automaticPaymentRemindersSettings,
        activationDate: new Date(automaticPaymentRemindersSettings.activationDate),
      }
    },
    [organizationName, t],
  )

  const { data, ...rest } = useQuery(
    [QueryKeys.PaymentRemindersSettings],
    () => getAutomaticPaymentRemindersSettings(),
    { select: selectPaymentRemindersSettings },
  )

  return { automaticPaymentRemindersSettings: data, ...rest }
}
